import y from "../common/base-provider.js";
import { newInAppMessageFromJson as lt } from "../InAppMessage/in-app-message-factory.js";
import ue from "../models/braze-event.js";
import { InAppMessage } from "../InAppMessage/index.js";
import {
  isArray as p,
  isEqual as ii,
  validateValueIsFromEnum as F
} from "../util/code-utils.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import wt from "../InAppMessage/models/templated-in-app-message.js";
import pt from "./models/trigger.js";
import V from "./models/trigger-events.js";
import r from "../../shared-lib/braze-shared-lib.js";
export default class gr extends y {
  constructor(t, i, s, e, r) {
    super(),
      (this.tg = t),
      (this.yt = i),
      (this.h = s),
      (this.Ci = e),
      (this.ig = r),
      (this.sg = []),
      (this.eg = []),
      (this.hg = null),
      (this.og = {}),
      (this.ng = {}),
      this.lg(),
      this.ag();
  }
  gg() {
    (this.hg = this.h.I(o.q.Na) || this.hg),
      (this.og = this.h.I(o.q.va) || this.og),
      (this.ng = this.h.I(o.q.Ga) || this.ng);
    for (let t = 0; t < this.fg.length; t++) {
      const i = this.fg[t];
      null != this.ng[i.id] && i.zu(this.ng[i.id]);
    }
  }
  lg() {
    this.cg = this.h.I(o.q.Da) || 0;
    const t = this.h.I(o.q.Ya) || [],
      i = [];
    for (let s = 0; s < t.length; s++) i.push(pt.Pn(t[s]));
    (this.fg = i), this.gg();
  }
  ag() {
    const t = this,
      i = function(i, s, e, r, h) {
        return function() {
          t.ug(i, s, e, r, h);
        };
      },
      s = {};
    for (let t = 0; t < this.fg.length; t++) s[this.fg[t].id] = this.fg[t];
    let e = !1;
    for (let t = 0; t < this.fg.length; t++) {
      const r = this.fg[t];
      if (null != this.og[r.id]) {
        const t = this.og[r.id],
          h = [];
        for (let e = 0; e < t.length; e++) {
          const o = t[e],
            n = r.Iu(o.Ui);
          if (n > 0) {
            let t, e;
            h.push(o),
              null != o.dg && (t = o.dg),
              null != o.mg && ue.Fa(o.mg) && (e = ue.Pn(o.mg));
            const l = [];
            if (p(o.pg))
              for (let t = 0; t < o.pg.length; t++) {
                const i = s[o.pg[t]];
                null != i && l.push(i);
              }
            this.eg.push(setTimeout(i(r, o.Ui, t, e, l), n));
          }
        }
        this.og[r.id].length > h.length &&
          ((this.og[r.id] = h),
          (e = !0),
          0 === this.og[r.id].length && delete this.og[r.id]);
      }
    }
    e && this.h.B(o.q.va, this.og);
  }
  bg() {
    const t = [];
    for (let i = 0; i < this.fg.length; i++) t.push(this.fg[i].ss());
    (this.cg = new Date().valueOf()),
      this.h.B(o.q.Ya, t),
      this.h.B(o.q.Da, this.cg);
  }
  Tg() {
    (this.h.I(o.q.Da) || 0) > this.cg ? this.lg() : this.gg();
  }
  Rs(t) {
    let i = !1;
    if (null != t && t.triggers) {
      this.gg();
      const s = {},
        e = {};
      this.fg = [];
      for (let r = 0; r < t.triggers.length; r++) {
        const h = pt.fromJson(t.triggers[r]);
        null != this.ng[h.id] &&
          (h.zu(this.ng[h.id]), (s[h.id] = this.ng[h.id])),
          null != this.og[h.id] && (e[h.id] = this.og[h.id]);
        for (let t = 0; t < h.Du.length; t++)
          if (h.Du[t].ec(V.ks, null)) {
            i = !0;
            break;
          }
        null != h && this.fg.push(h);
      }
      ii(this.ng, s) || ((this.ng = s), this.h.B(o.q.Ga, this.ng)),
        ii(this.og, e) || ((this.og = e), this.h.B(o.q.va, this.og)),
        this.bg(),
        i &&
          (r.D.info("Trigger with test condition found, firing test."),
          this.je(V.ks)),
        this.je(V.OPEN);
      const h = this.sg;
      this.sg = [];
      for (let t = 0; t < h.length; t++) this.je.apply(this, h[t]);
    }
  }
  ug(t, i, s, e, h) {
    const o = e => {
        this.gg();
        const h = new Date().valueOf();
        if (!t.$u(i))
          return !1 === navigator.onLine && t.type === pt.Ki.Ji && e.imageUrl
            ? (r.D.info(
                `Not showing ${t.type} trigger action ${t.id} due to offline state.`
              ),
              void this.ig.Ye(t.id, InAppMessage.Me.Dh))
            : void (t.vu(h) && this.yg(t, h, s)
                ? 0 === this.yt.bu()
                  ? r.D.info(
                      `Not displaying trigger ${t.id} because neither automaticallyShowInAppMessages() nor subscribeToInAppMessage() were called.`
                    )
                  : (this.yt.St([e]), this.vg(t, h))
                : r.D.info(
                    `Not displaying trigger ${t.id} because display time fell outside of the acceptable time window.`
                  ));
        t.type === pt.Ki.Mu
          ? this.ig.Ye(t.id, InAppMessage.Me.Ri)
          : this.ig.Ye(t.id, InAppMessage.Me.Mh);
      },
      n = () => {
        this.gg();
        const o = h.pop();
        if (null != o)
          if ((this.wg(o, i, s, e, h), o.$u(i))) {
            let t = `Server aborted in-app message display, but the timeout on fallback trigger ${o.id} has already elapsed.`;
            h.length > 0 && (t += " Continuing to fall back."),
              r.D.info(t),
              this.ig.Ye(o.id, InAppMessage.Me.Mh),
              n();
          } else {
            r.D.info(
              `Server aborted in-app message display. Falling back to lower priority ${o.type} trigger action ${t.id}.`
            );
            const n = 1e3 * o.Pu - (new Date().valueOf() - i);
            n > 0
              ? this.eg.push(
                  setTimeout(() => {
                    this.ug(o, i, s, e, h);
                  }, n)
                )
              : this.ug(o, i, s, e, h);
          }
      };
    let l, a, g;
    switch (t.type) {
      case pt.Ki.Ji:
        if (((l = lt(t.data)), null == l)) {
          r.D.error(
            `Could not parse trigger data for trigger ${t.id}, ignoring.`
          ),
            this.ig.Ye(t.id, InAppMessage.Me.Li);
          break;
        }
        if (((a = this.ig.Bi(l)), a)) {
          r.D.error(a), n();
          break;
        }
        o(l);
        break;
      case pt.Ki.Mu:
        if (((g = wt.fromJson(t.data, o, n, i, t.Vi)), null == g)) {
          r.D.error(
            `Could not parse trigger data for trigger ${t.id}, ignoring.`
          ),
            this.ig.Ye(t.id, InAppMessage.Me.Li);
          break;
        }
        this.ig.qi(g, s, e);
        break;
      default:
        r.D.error(
          `Trigger ${t.id} was of unexpected type ${t.type}, ignoring.`
        ),
          this.ig.Ye(t.id, InAppMessage.Me.Li);
    }
  }
  je(t, i, s) {
    if (!F(V, t, "Cannot fire trigger action.", "TriggerEvents")) return;
    if (this.Ci.Ll())
      return (
        r.D.info(
          "Trigger sync is currently in progress, awaiting sync completion before firing trigger event."
        ),
        void this.sg.push(arguments)
      );
    this.Tg();
    const e = new Date().valueOf(),
      h = e - this.hg;
    let o = !0,
      n = !0;
    const l = [];
    for (let s = 0; s < this.fg.length; s++) {
      const r = this.fg[s],
        h = e + 1e3 * r.Pu;
      if (
        r.vu(h) &&
        (null == r.startTime || r.startTime <= e) &&
        (null == r.endTime || r.endTime >= e)
      ) {
        let s = !1;
        for (let e = 0; e < r.Du.length; e++)
          if (r.Du[e].ec(t, i)) {
            s = !0;
            break;
          }
        s && ((o = !1), this.yg(r, h, t) && ((n = !1), l.push(r)));
      }
    }
    if (o)
      return void r.D.info(
        `Trigger event ${t} did not match any trigger conditions.`
      );
    if (n)
      return void r.D.info(
        `Ignoring ${t} trigger event because a trigger was displayed ${h /
          1e3}s ago.`
      );
    l.sort((t, i) => t.priority - i.priority);
    const a = l.pop();
    null != a &&
      (r.D.info(
        `Firing ${a.type} trigger action ${a.id} from trigger event ${t}.`
      ),
      this.wg(a, e, t, s, l),
      0 === a.Pu
        ? this.ug(a, e, t, s, l)
        : this.eg.push(
            setTimeout(() => {
              this.ug(a, e, t, s, l);
            }, 1e3 * a.Pu)
          ));
  }
  changeUser(t) {
    if (((this.fg = []), this.h.Xs(o.q.Ya), !t)) {
      (this.sg = []), (this.hg = null), (this.ng = {}), (this.og = {});
      for (let t = 0; t < this.eg.length; t++) clearTimeout(this.eg[t]);
      (this.eg = []), this.h.Xs(o.q.Na), this.h.Xs(o.q.Ga), this.h.Xs(o.q.va);
    }
  }
  clearData() {
    (this.fg = []), (this.hg = null), (this.ng = {}), (this.og = {});
    for (let t = 0; t < this.eg.length; t++) clearTimeout(this.eg[t]);
    this.eg = [];
  }
  yg(t, i, s) {
    if (null == this.hg) return !0;
    if (s === V.ks)
      return (
        r.D.info(
          "Ignoring minimum interval between trigger because it is a test type."
        ),
        !0
      );
    let e = t.wu;
    return null == e && (e = this.tg), i - this.hg >= 1e3 * e;
  }
  wg(t, i, s, e, r) {
    this.gg(), (this.og[t.id] = this.og[t.id] || []);
    const h = {};
    let n;
    (h.Ui = i), (h.dg = s), null != e && (n = e.ss()), (h.mg = n);
    const l = [];
    for (let t = 0; t < r.length; t++) l.push(r[t].id);
    (h.pg = l), this.og[t.id].push(h), this.h.B(o.q.va, this.og);
  }
  vg(t, i) {
    this.gg(),
      t.zu(i),
      (this.hg = i),
      this.h.B(o.q.Na, i),
      (this.ng[t.id] = i),
      this.h.B(o.q.Ga, this.ng);
  }
}
